import { post } from '../../shared/utils/fetch.util'
const OLD_EVENTS_URL = '/v2/events'

export const logOldEvents = (body, headers) => post(`/v2/events`, body, headers)
